import type { UnwrapRef} from 'vue'
import {computed, readonly, ref} from 'vue'
import {useStore} from 'vuex'

export const usePagination = <SortKey extends string>() => {
  const store = useStore()
  const currentPage = ref<number>(1)
  const setCurrentPage = (page: number) => {
    currentPage.value = page
  }
  const displayNumber = computed<number>(() => store.getters['filters/displayNumber'])
  const setDisplayNumber = (num: number) => store.dispatch('filters/setDisplayNumber', num)
  const sortKey = ref<SortKey | undefined>(undefined)
  const setSortKey = (key: UnwrapRef<SortKey>) => {
    sortKey.value = key
  }
  const resetSortKey = () => {
    sortKey.value = undefined
  }
  const sortOrder = ref<'desc' | 'asc' | undefined>(undefined)
  const setSortOrder = (order: 'desc' | 'asc') => {
    sortOrder.value = order
  }
  const resetSortOrder = () => {
    sortOrder.value = undefined
  }

  return {
    currentPage: readonly(currentPage),
    displayNumber: readonly(displayNumber),
    sortKey: readonly(sortKey),
    sortOrder: readonly(sortOrder),
    setCurrentPage,
    setDisplayNumber,
    setSortOrder,
    setSortKey,
    resetSortOrder,
    resetSortKey,
  }
}
